import { PileupGetGlobalValueForTag, PileupGetVisibleModifications, PileupGetReducedFeatures } from './rpcMethods';
export default (function (pm) {
  pm.addRpcMethod(function () {
    return new PileupGetGlobalValueForTag(pm);
  });
  pm.addRpcMethod(function () {
    return new PileupGetVisibleModifications(pm);
  });
  pm.addRpcMethod(function () {
    return new PileupGetReducedFeatures(pm);
  });
});